import { constants } from "@newsela/angelou";

const { colors } = constants;
const darkBlue = colors.ui.core[700];

export const textCss = {
  color: darkBlue,
  textTransform: "capitalize",
};
